import { useEffect, useState } from 'react';
import AuthenticatedLayout from '../layouts/AuthenticatedLayout';
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";

export default function Dashboard() {
    const navigate = useNavigate()
    const [user, setUser] = useState(null);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const userData = localStorage.getItem('wp_user');
        if (userData) {
            setUser(JSON.parse(userData));
        }

        // Fetch dashboard stats
        const fetchStats = async () => {
            setLoading(true);
            const token = localStorage.getItem('wp_jwt');
            const apiUrl = process.env.REACT_APP_WORDPRESS_URL;

            try {
                const res = await fetch(`${apiUrl}/wp-json/biznis/v1/dashboard-stats`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = await res.json();

                if (data?.data?.status === 403) {
                    // Handle session expired
                    localStorage.removeItem('wp_jwt');
                    localStorage.removeItem('wp_user');
                    Swal.fire({
                        html: 'Session Expired',
                        icon: 'error',
                        showConfirmButton: false,
                        timer: 3000,
                        position: "bottom-end",
                    });
                    setTimeout(() => {
                        navigate('/login');
                    }, 2000);
                    return;
                }

                if (!res.ok) {
                    throw new Error('Failed to fetch dashboard stats');
                }

                setStats(data);
            } catch (err) {
                console.error('Failed to fetch stats:', err);
            } finally {
                setLoading(false);
            }
        };


        fetchStats();
    }, []);

    const StatCard = ({ label, value, color, onClick }) => (
        <div className={`p-8 rounded-xl shadow-md text-blue-950 cursor-pointer ${color}`} onClick={onClick}>
            <div className="text-sm font-medium">{label}</div>
            <div className="text-2xl font-bold mt-1">{value}</div>
        </div>
    );

    const handleNavigateToBusinesses = () => {
        navigate('/biznisi')
    }
    const handleNavigateToCategories = () => {
        navigate('/kategorije')
    }

    return (
        <AuthenticatedLayout
            user={user}
            header={<h2 className="font-semibold text-xl text-white leading-tight">Dashboard</h2>}
        >
            <div className="mt-6 max-w-7xl mx-auto sm:px-6 lg:px-8">
                {loading ? (
                        <div className="flex flex-col w-full items-center">
                            <div className="animate-spin border-2 border-t-2 border-blue-950 w-5 h-5 rounded-full"></div>
                        </div>
                    ) :
                    <>
                        {stats && (
                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
                                <StatCard label="Ukupno biznisa" value={stats.total} color="bg-blue-100" onClick={handleNavigateToBusinesses} />
                                <StatCard label="Aktivni za prodaju" value={stats.active} color="bg-green-100" onClick={handleNavigateToBusinesses}/>
                                <StatCard label="U pregovorima" value={stats.negotiation} color="bg-yellow-100" onClick={handleNavigateToBusinesses} />
                                <StatCard label="Prodani" value={stats.sold} color="bg-red-100" onClick={handleNavigateToBusinesses} />
                                <StatCard label="Ukupno kategorija" value={stats.categories} color="bg-indigo-100" onClick={handleNavigateToCategories} />
                            </div>
                        )}
                        {stats && (
                            <div className="grid grid-cols-4 gap-4 my-4">
                                {/* 3/4 width */}
                                <div className="col-span-3 bg-white p-4 shadow rounded-xl">
                                    <h3 className="font-semibold text-lg mb-2">Vrhunska poduzeća (Na prodaju)</h3>
                                    <table className="w-full text-sm text-left">
                                        <thead>
                                        <tr className="border-b">
                                            <th className="py-2">ID BROJ</th>
                                            <th className="py-2">Naziv</th>
                                            <th className="py-2">Cijena</th>
                                            <th className="py-2">Pogledi</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {stats.recent_listings.map(item => (
                                            <tr key={item.id} className="border-b hover:bg-gray-100">
                                                <td className="py-2">{item.listing_id}</td>
                                                <td className="py-2">{item.title}</td>
                                                <td className="py-2">{item.price || 'N/A'}</td>
                                                <td className="py-2">{item.view_count}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* 1/4 width */}
                                <div className="col-span-1 bg-white p-4 shadow rounded-xl">
                                    <h3 className="font-semibold text-lg mb-2">Top Kategorije</h3>
                                    <table className="w-full text-sm text-left">
                                        <thead>
                                        <tr className="border-b">
                                            <th className="py-2">Naziv</th>
                                            <th className="py-2">Broj</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {stats.recent_categories.map(cat => (
                                            <tr key={cat.id} className="border-b hover:bg-gray-100">
                                                <td className="py-2">{cat.name}</td>
                                                <td className="py-2">{cat.count}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </>
                }

            </div>
        </AuthenticatedLayout>
    );
}
